import React from "react";

interface Props {
  Titel: string;
  total: string;
  extra1?: string;
  extra1amount?: string;
  extra2?: string;
  extra2amount?: string;
  extra3?: string;
  extra3amount?: string;
}

const DetailCard = ({
  Titel,
  total,
  extra1,
  extra1amount,
  extra2,
  extra2amount,
  extra3,
  extra3amount,
}: Props) => {
  return (
    <div className="w-[45%] h-[30%] bg-gray-100 m-1 rounded-md border-2 border-gray-300">
      <h1 className="border-b-2 border-gray-200 p-2 text-sm text-gray-500">
        {Titel}
      </h1>
      <h2 className="text-xl font-semibold px-3 pt-3 pb-1">{total}</h2>
      <div className="flex flex-row justify-between px-3 text-sm">
        <div className="text-gray-500">
          <p>{extra1}</p>
          <p>{extra2}</p>
          <p>{extra3}</p>
        </div>
        <div>
          <p>{extra1amount}</p>
          <p>{extra2amount}</p>
          <p>{extra3amount}</p>
        </div>
      </div>
    </div>
  );
};

export default DetailCard;
